var map = {
	"./bebote.png": 986,
	"./bg.png": 987,
	"./cervecitas.png": 988,
	"./chica_movil.png": 989,
	"./chico.png": 990,
	"./construcciones.png": 991,
	"./deporte.png": 992,
	"./news.png": 993,
	"./salon.png": 994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 985;